import { useState, useCallback } from 'react'
import { useSpring, SpringValue } from 'react-spring'

const springConfig = {
  mass: 1,
  tension: 200,
  friction: 30,
}

interface UseAnimationsResult {
  isHover: boolean
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  topBarSpring: Record<string, SpringValue>
  middleBarSpring: Record<string, SpringValue>
  bottomBarSpring: Record<string, SpringValue>
}

export function useAnimations(isClicked: boolean): UseAnimationsResult {
  const [isHover, setHover] = useState(false)

  const handleMouseEnter = useCallback(() => setHover(true), [])
  const handleMouseLeave = useCallback(() => setHover(false), [])

  const topBarSpring = useSpring({
    to: {
      transform: isClicked
        ? 'rotate(135deg) translate3d(0, 8px, 0) '
        : 'rotate(0deg) translate3d(0, 0px, 0)',
      transformOrigin: '12px 9px',
    },
    config: springConfig,
  })

  const middleBarSpring = useSpring({
    to: {
      transform: isClicked
        ? 'rotate(0deg) translate3d(-18px, 0px, 0)'
        : isHover
        ? 'rotate(0deg) translate3d(-4px, 0px, 0)'
        : 'rotate(0deg) translate3d(0px, 0px, 0)',
      opacity: isClicked ? 0 : 1,
    },
    config: springConfig,
  })

  const bottomBarSpring = useSpring({
    to: {
      transform: isClicked
        ? 'rotate(-135deg) translate3d(0, -8px, 0) '
        : 'rotate(0deg) translate3d(0, 0px, 0)',
      transformOrigin: '12px 9px',
    },
    config: springConfig,
  })

  return {
    isHover,
    handleMouseEnter,
    handleMouseLeave,
    topBarSpring,
    middleBarSpring,
    bottomBarSpring,
  }
}
